import React, { useState } from "react";
import { Button, Card, Col, Modal } from "react-bootstrap";

const SingleProject = ({ singleProject }) => {
    const [show, setShow] = useState(false);
    const {
        title,
        name,
        type,
        banner,
        img,
        technology,
        tools,
        liveSite,
        clientCode,
        serverCode,
        description,
    } = singleProject;
    const handleShow = () => setShow(true);
    console.log(serverCode);
    return (
        <Col>
            <Card bg="dark">
                <Card.Body>
                    <Card.Title className="m-0">{title}</Card.Title>
                    <Card.Text>
                        <small className="text-success">{type}</small>
                    </Card.Text>
                </Card.Body>
                <Card.Img variant="bottom" src={banner} />
                <Card.Footer>
                    <p className="d-flex justify-content-between m-0">
                        <a
                            target="_blank"
                            className="btn btn-secondary"
                            rel="noreferrer"
                            href={liveSite}
                        >
                            View
                        </a>
                        <Button className="me-2" onClick={handleShow}>
                            Details
                        </Button>
                    </p>
                </Card.Footer>
            </Card>
            <>
                <Modal
                    size="lg"
                    show={show}
                    fullscreen={true}
                    onHide={() => setShow(false)}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>{title}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="container">
                        <div className="row">
                            <div className="col-sm-12 col-md-6">
                                <div
                                    style={{
                                        height: "75vh",
                                        overflowY: "scroll",
                                        padding: "10px 20px",
                                        display: "inline-block",
                                    }}
                                    className="my-2"
                                >
                                    <img
                                        className="img-fluid"
                                        src={img}
                                        alt={title}
                                    />
                                </div>
                                <p className="d-flex justify-content-between m-0">
                                    <a
                                        target="_blank"
                                        className="btn btn-info"
                                        rel="noreferrer"
                                        href={liveSite}
                                    >
                                        Live Site
                                    </a>
                                    <a
                                        target="_blank"
                                        className="btn btn-success"
                                        rel="noreferrer"
                                        href={clientCode}
                                    >
                                        Client Code
                                    </a>
                                    {serverCode && (
                                        <a
                                            target="_blank"
                                            className="btn btn-primary"
                                            rel="noreferrer"
                                            href={serverCode}
                                        >
                                            Server Code
                                        </a>
                                    )}
                                </p>
                            </div>
                            <div className="col-sm-12 col-md-6 p-3">
                                <h3>{name}</h3>
                                <h5>
                                    Technology:
                                    {technology.map((item) => (
                                        <span
                                            style={{ display: "inline-block" }}
                                            key={item}
                                            className=" mx-2 my-1 rounded fw-thin p-1 fs-6 border border-danger"
                                        >
                                            {item}
                                        </span>
                                    ))}
                                </h5>
                                <h5>
                                    Tools:
                                    {tools.map((item) => (
                                        <span
                                            style={{ display: "inline-block" }}
                                            key={item}
                                            className=" mx-2 my-1 rounded fw-thin p-1 fs-6 border border-success"
                                        >
                                            {item}
                                        </span>
                                    ))}
                                </h5>
                                <h4>Features:</h4>
                                <div>
                                    <ul>
                                        {description.map((item) => (
                                            <li
                                                style={{ display: "block" }}
                                                key={item}
                                                className=" mx-2 my-1 rounded fw-thin p-1 fs-6"
                                            >
                                                {item}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </>
        </Col>
    );
};

export default SingleProject;
